import { ApiFunc, getInstance } from '@helpers/httpClient'

import * as API from '../constants/api'

const instance = getInstance()

export const guestAll: ApiFunc<`${typeof API.USER_GUEST_ALL}`, 'get'> = params =>
  instance.get(API.USER_GUEST_ALL, {
    params,
  })

export const guestList: ApiFunc<`${typeof API.USER_GUEST}`, 'get'> = params =>
  instance.get(API.USER_GUEST, {
    params,
  })

export const guestDeleteCourse: ApiFunc<`${typeof API.USER_GUEST_DELETE_COURSE}`, 'delete'> = params =>
  instance.delete(API.USER_GUEST_DELETE_COURSE, {
    params,
  })
